import React from "react";
import { connect } from "scrivito";
import { Layout, SentryErrorBoundary, ToastContainerWrapper } from "components";
import { Provider as NiceModalProvider } from "@ebay/nice-modal-react";
import {
  AppBaseProvider,
  ConfiguratorPopupProvider,
  CookieConsentProvider,
  HelmetWrapperProvider,
  PageLoadStateProvider,
  ProjectSummarySidebarProvider,
  UrqlProvider,
} from "providers";
import "react-toastify/dist/ReactToastify.css";
import { SharedWorkerProvider } from "providers/SharedWorkerProvider/SharedWorkerProvider";
import { CallHooks } from "./CallHooks";

const App = connect(({ callback }) => (
  <div ref={callback}>
    <HelmetWrapperProvider>
      <SentryErrorBoundary>
        <CookieConsentProvider>
          <PageLoadStateProvider>
            <AppBaseProvider>
              <UrqlProvider>
                <CallHooks />
                <SharedWorkerProvider>
                  <ConfiguratorPopupProvider>
                    <NiceModalProvider>
                      <ProjectSummarySidebarProvider>
                        <div className="min-vh-100 d-flex flex-column">
                          <ToastContainerWrapper />
                          <Layout />
                        </div>
                      </ProjectSummarySidebarProvider>
                    </NiceModalProvider>
                  </ConfiguratorPopupProvider>
                </SharedWorkerProvider>
              </UrqlProvider>
            </AppBaseProvider>
          </PageLoadStateProvider>
        </CookieConsentProvider>
      </SentryErrorBoundary>
    </HelmetWrapperProvider>
  </div>
));

export default App;
